import { getFloat, roundPrice } from '../../../../../helper'

export const filterTipsString = v => v.replace(/[^0-9.,]/g, '')

export const getPercentsTips = (discount, itemsTotal) => {
	if (discount) {
		return roundPrice(itemsTotal * discount / 100.0)
	} else {
		return 0
	}
}

export const getPriceWithTips = (itemsTotal, discount) => {
	return roundPrice(itemsTotal + getFloat(discount))
}

export const handleInputChange = (inputValue, setCustomerGivenSum) => {
	const filter = v => v.replace(/[^0-9.,]/g, '')
	if (/^-?\d*\.?\d*$/.test(inputValue) || (/^-?\d*\.?\d*,$/.test(inputValue))) {
		setCustomerGivenSum(inputValue.replace('.', ','))
	} else {
		inputValue = filter(inputValue).replace('.', ',')
		setCustomerGivenSum(inputValue)
	}
}

export const getErrorMessage = (paymentSession, createSessionError, t, errorCardReadType) => {

	if (createSessionError) {
		return t('Tap2PayModals.process.createSessionError')
	}

	if (paymentSession?.status === 'CANCELED') {
		return t('Tap2PayModals.process.paymentIsCanceled')
	}

	if (errorCardReadType === 'CARD_TRANSACTION_DECLINED') {
		return t('Tap2PayModals.process.cardDeclined')
	}

	if (errorCardReadType === 'CARD_READ_TIMED_OUT') {
		return t('Tap2PayModals.process.cardNotRead')
	}

	return t('Tap2PayModals.process.status_error')

}

export const getDeviceIntegrityErrorInfo = ({ t, errorType }) => {
	if (!errorType) {
		return null
	}

	switch (errorType) {
		case 'DEVICE_TAMPERED':
			return {
				icon: 'error',
				message: t('Tap2PayModals.process.deviceIntegrity.deviceTampered'),
			}

		case 'INSECURE_ENVIRONMENT':
			return {
				icon: 'phone-calling',
				message: t('Tap2PayModals.process.deviceIntegrity.insecureEnvironment'),
			}

		case 'GELOCATION_PERMISSION_DENIED':
			return {
				icon: 'geolocation-off',
				message: t('Tap2PayModals.process.deviceIntegrity.locationPermission'),
			}

		case 'PAYMENT_DISABLED_DURING_CALL':
			return {
				icon: 'phone-calling',
				message: t('Tap2PayModals.process.deviceIntegrity.callActive'),
			}

		case 'NOT_CONNECTED_TO_READER':
			return {
				icon: 'nfc',
				message: t('Tap2PayModals.process.deviceIntegrity.noReaderConnection'),
			}

		default:
			return {
				icon: null,
				message: t('Tap2PayModals.process.deviceIntegrity.unknownError'),
			}
	}
}
